import { DataTransferHorizontalIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';

interface TransferButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

function TransferButton({ onClick, disabled }: TransferButtonProps) {
  return (
    <Button
      btnType="tertiary"
      disabled={disabled}
      noMargin
      size="med"
      grow
      gap="4px"
      onClick={onClick}
    >
      <DataTransferHorizontalIcon width={14} height={14} />
      Transfer
    </Button>
  );
}

export default TransferButton;
